import { guardClient } from '../_axios'

const API_USERS = '/users'
/**
 * ユーザーの削除
 * @param request
 * @returns
 */
export type DeleteUserRequestType = {
  userId: string
}
export const deleteUser = async (request: DeleteUserRequestType) => {
  const requestUrl = `${API_USERS}/${request.userId}`
  const response = await guardClient.delete(requestUrl)
  return response.data
}
